import { Observable } from "rxjs";
import { BRANDSETTINGS } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const createOrderMinMaxRulesEpic = (action$, store) => {
    return action$
        .ofType(BRANDSETTINGS.ORDERMINMAX.CREATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((rule) => {
            return ajax({
                method: "POST",
                body: rule,
                url: `${siteConfig.api}/brand/orders/minmax`,
            })
                .map(({ response, status }) => {
                    if (response && status === 201) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving order rule") })),
                            {
                                payload: [],
                                error: true,
                                type: BRANDSETTINGS.ORDERMINMAX.CREATE.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: BRANDSETTINGS.ORDERMINMAX.CREATE.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error saving order rule");

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRANDSETTINGS.ORDERMINMAX.CREATE.COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const UpdateOrderMinMaxRulesEpic = (action$, store) => {
    return action$
        .ofType(BRANDSETTINGS.ORDERMINMAX.UPDATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((rule) => {
            return ajax({
                method: "PATCH",
                body: rule,
                url: `${siteConfig.api}/brand/orders/minmax`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving order rule") })),
                            {
                                payload: [],
                                error: true,
                                type: BRANDSETTINGS.ORDERMINMAX.UPDATE.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: BRANDSETTINGS.ORDERMINMAX.UPDATE.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error saving order rule");

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRANDSETTINGS.ORDERMINMAX.UPDATE.COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const deleteOrderMinMaxRulesEpic = (action$, store) => {
    return action$
        .ofType(BRANDSETTINGS.ORDERMINMAX.DELETE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((ruleId) => {
            return ajax({
                method: "DELETE",
                url: `${siteConfig.api}/brand/orders/minmax/${ruleId}`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error removing order rule") })),
                            {
                                payload: [],
                                error: true,
                                type: BRANDSETTINGS.ORDERMINMAX.DELETE.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: BRANDSETTINGS.ORDERMINMAX.DELETE.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error removing order rule");

                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRANDSETTINGS.ORDERMINMAX.DELETE.COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const fetchOrderMinMaxRulesEpic = (action$, store) => {
    return action$
        .ofType(BRANDSETTINGS.ORDERMINMAX.FETCH.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((ruleId) => {
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/brand/orders/minmax/${ruleId}`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false, status };
                    } else {
                        return { error: true, result: [], status };
                    }
                })
                .flatMap(({ result, error, status }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error fetching order rule") })),
                            {
                                payload: result,
                                error: true,
                                type: BRANDSETTINGS.ORDERMINMAX.FETCH.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: BRANDSETTINGS.ORDERMINMAX.FETCH.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error fetching order rule");

                    if (error && error.status === 404) {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                payload: ruleId,
                                type: BRANDSETTINGS.ORDERMINMAX.FETCH.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    } else {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                payload: new Error(errorMessage),
                                type: BRANDSETTINGS.ORDERMINMAX.FETCH.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    }
                });
        });
};
